import { Badge, BadgesStats } from '../Models';

export abstract class WritingBadge extends Badge {
  public abstract readonly evaluateIfAchieved: (stats: BadgesStats) => boolean;
}



// WEBPACK FOOTER //
// ./src/containers/Badges/AllBadges/WritingBadge.ts